import DTO from './DTO';

class VisitDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'driver_name',
        type: String,
        validators: {},
        labelKey: 'driver_name',
      },
      {
        name: 'driver_id',
        type: String,
        validators: {},
        labelKey: 'driver_id',
      },
      {
        name: 'trip_cost',
        type: String,
        validators: {},
        labelKey: 'trip_cost',
      },
      {
        name: 'start_point',
        type: String,
        validators: {},
        labelKey: 'start_point',
      },
      {
        name: 'end_point',
        type: String,
        validators: {},
        labelKey: 'end_point',
      },
      {
        name: 'intermediate_point',
        type: String,
        validators: {},
        labelKey: 'intermediate_point',
      },
      {
        name: 'registry_presence',
        type: String,
        validators: {},
        labelKey: 'registry_presence',
      },
      {
        name: 'carrier',
        type: String,
        validators: {},
        labelKey: 'carrier',
      },
      {
        name: 'registry_presence',
        type: String,
        validators: {},
        labelKey: 'registry_presence',
      },
      {
        name: 'grn_ts',
        type: String,
        validators: {},
        labelKey: 'grn_ts',
      },
      {
        name: 'trip_started_at',
        type: Date,
        validators: {},
        labelKey: 'trip_started_at',
      },
      {
        name: 'trip_started_end',
        type: Date,
        validators: {},
        labelKey: 'trip_started_end',
      },
      {
        name: 'trip_end_date_from',
        type: Date,
        validators: {},
        labelKey: 'trip_end_date_from',
      },
      {
        name: 'trip_end_date_to',
        type: Date,
        validators: {},
        labelKey: 'trip_end_date_to',
      },
      // Дополнил исходя из названий полей в журнале иных сведений
      {
        name: 'carrier_external_id',
        type: String,
        validators: [],
        labelKey: 'carrier.external_id',
      },
      {
        name: 'trip_started_at',
        type: String,
        validators: [],
        labelKey: 'visit.start_date_time',
      },
      {
        name: 'trip_ended_at',
        type: String,
        validators: [],
        labelKey: 'visit.end_date_time',
      },
      {
        name: 'trip_start_point',
        type: String,
        validators: [],
        labelKey: 'visit.start_point',
      },
      {
        name: 'trip_intermediate_points',
        type: String,
        validators: [],
        labelKey: 'visit.trip_intermediate_points',
      },
      {
        name: 'trip_end_point',
        type: String,
        validators: [],
        labelKey: 'visit.end_point',
      },
      {
        name: 'trip_cost',
        type: String,
        validators: [],
        labelKey: 'trip_cost',
      },
      {
        name: 'driver_external_id',
        type: String,
        validators: [],
        labelKey: 'driver.external_id',
      },
      {
        name: 'vehicle_external_id',
        type: String,
        validators: [],
        labelKey: 'vehicle.external_id',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default VisitDTO;
